module.exports = __webpack_public_path__ + "static/ey-1-sq-283666fd8e9aa864e40429981deea51a.png";